import { api } from '@/api/client'
import { queryClient } from '@/api/queryClient'
import { clearCurrentCondo } from '@/access/currentCondo'
import { sessionStore } from './sessionStore'

/** Revokes the web session server-side (best effort), then clears tokens and cached data. */
export async function logout(): Promise<void> {
  try {
    if (sessionStore.getAccessToken()) await api.post('/auth/web-sessions/logout')
  } catch {
    // The local logout must happen even if the server is unreachable or the token is stale.
  }
  sessionStore.clear()
  queryClient.clear()
  clearCurrentCondo()
}
